"use client";

import Quote from "@homeinstead/icons/Quote";

type TestimonialItemProps = {
  item: { name?: string | null; text?: string | null };
};

/**
 * Studio stores the speaker's name on its own. The homepage quote paints the
 * em dash with that name, so add it unless it is already there.
 */
function formatAttribution(name: string): string | null {
  const trimmed = name.trim();

  if (!trimmed) {
    return null;
  }

  if (trimmed.startsWith("—")) {
    return trimmed;
  }

  return `— ${trimmed}`;
}

function TestimonialItem({ item }: TestimonialItemProps) {
  if (!item.text) {
    return null;
  }

  const attribution = item.name ? formatAttribution(item.name) : null;

  return (
    // Homepage info panel: a 64px mark, then quote and attribution as
    // figure children (figcaption last) so AT associates the speaker line.
    <figure className="ml-auto flex w-full max-w-lg flex-col items-end gap-4 pr-6 text-right text-base leading-6">
      <div className="flex h-16 w-16 shrink-0 items-center justify-center">
        <Quote
          aria-hidden="true"
          className="[&_path]:fill-surface-foreground h-full w-full"
        />
      </div>
      <blockquote className="w-full">{item.text}</blockquote>
      {attribution ? (
        <figcaption className="font-bold">{attribution}</figcaption>
      ) : null}
    </figure>
  );
}

export { TestimonialItem };
